const handleLinkClick = (event) => {
  try {
    const clickedEl = event.target;
    const linkEl = clickedEl.closest("[data-link]");

    if (linkEl && linkEl.dataset.link.trim() !== "") {
      event.preventDefault(); // cancel any default behaviour
      const href = linkEl.dataset.link;
      const target = linkEl.dataset.target;

      if (event.metaKey || event.ctrlKey || target === "_blank") {
        window.open(href, "_blank"); // open in new tab when cmd/ctrl-click or target="_blank"
      } else {
        window.location.href = href; // otherwise navigate in the current tab
      }
    }
  } catch (error) {
    console.error("data-link navigation error:", error);
  }
};

document.addEventListener("click", handleLinkClick);
